import * as angular from "angular";
import {IController} from "angular";
import {OmsOrderStatusType} from "../../types/oms-order-status.type";

export class OmsOrderStatusSelectController implements IController {

  status: any;
  options: any;
  ngPlaceholder: any;
  enableAll: any;
  onChange: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {
    if (!this.options) {
      this.options = angular.copy(Object.values(OmsOrderStatusType));
    }
  }
}

angular
.module('bringoz.admin.oms')
.component('omsOrderStatusSelect', {
  bindings: {
    status: '<',
    options: '<?',
    ngPlaceholder: '@?',
    enableAll: '@?',
    onChange: '&'
  },
  template: require('./oms-order-status-select.html').default,
  controller: OmsOrderStatusSelectController
});
